
export const getCompositionParts = (item, type) => {
  return item &&
    item.productData &&
    item.productData.construction &&
    Array.isArray(item.productData.construction.composition)
    ? item.productData.construction.composition.filter(part => part.type === type)
    : []
}

export const getTechnicalValues = (item, type) => {
  return item &&
    item.productData &&
    item.productData.technicalValues &&
    typeof item.productData.technicalValues[type] !== 'undefined'
    ? [item.productData.technicalValues[type].value]
    : []
}

const getCompositionPartValues = (item, type) => {
  const values = []

  const parts = getCompositionParts(item, type)
  parts.map(part => values.push(part.value))

  return values
}

const availables = {

  render: ['org-1', 'min-1', null],

  pinsulation: ['msp-40', 'msp-50', 'msp-60', 'msp-100', 'mst-60', 'mst-100', 'wvhf-60', 'wvhf-80', 'wmo42-60', 'wmo42-80', 'wmo46-60', 'wmo50-60', 'pda-100', 'pda-140', null],

  outerPlanking: ['opg-12', 'opg-25','opg37', 'opg-33', 'opr-12', 'opc-16', null],

  stand: ['stae-80', 'stae-100', 'stae-140', 'stae-160', 'stae-180', 'stae-200', 'stae-240', 'stae-165'],

  compartmentInsulation: ['cigw-60', 'cigw-80', 'cigw-100', 'cigw-140', 'cigw-160', 'cigw-180', 'cigw-200', 'cigw-240', 'cirw-100', 'cirw-140', 'cirw-160', 'cirw-180', 'cirw-200', 'cicf-160', 'cicf-180',  'ciww-140', 'ciww-160'],

  innerPlanking1: ['ia-12', 'ib-15', 'ic-9', 'id-12', 'if-12', 'ig-15', 'ih-18', 'ii-16'],

  innerPlanking2: ['im-9', 'in-12', 'io-12', 'ip-15', 'iq-18', null],
  innerPlanking3: ['ig3-12', null],

  fireResistanceInner: ['F-30-B', 'F-60-B', 'F-90-B', 'K260', 'F-60-B-K260', 'F-90-B-K260'],

  fireResistanceOuter: ['F-30-B', 'F-60-B', 'F-90-B', 'K260', 'F-60-B-K260', 'F-90-B-K260'],

  heatTransferCoefficient: [0.11, 0.12, 0.13, 0.14, 0.15, 0.16, 0.18, 0.19, 0.2, 0.21, 0.23, 0.24, 0.27, 0.38, 0.45],

  impactSoundLevel: [30, 31, 32, 33, 34, 35, 36, 37, 40, 41, 45, 46, 50, 50.7, 51, 53, 54, 55, 56, 57, 58, 59, 61],

  insulation: ['m-15', 'm-20', 'm-30', 'm-40', 'w-4', 'w-20', 'w-30', 'w-40'],

  screed: ['d-18', 'd-20', 'd-22', 'd-25', 'w-50', 'w-60', 'w-70', 'nw-0'],

  soundReductionIndex: [43.8, 44, 47.6, 48.1, 48.2, 48.4, 48.9, 50.2, 50.4, 50.5, 50.7, 50.9, 51, 51.1, 51.2,  51.3, 51.4, 51.5, 51.6, 51.8, 52.5, 52.7, 53.7, 53, 53.1, 53.4, 54, 54.1, 54.5, 54.8, 55.8, 58.3, 58.7, 58.8, 59.4, 59.6],

  fireBehavior: ['A1A2', 'B1', 'B2', 'B3', null],

  suspendedCeiling: ['f-27', 'f-25', 'uas-80', 'ba-24', null], // 'h-100' , 'h-240', 'g-12.5'

  underfloorHeating: ['ufh-1', null],

  woodenPanel: [25, 22, null],

  soundInsulation: ['si-20', 'si-25', 'si-30', null]

}

export default availables

export const objMap = {

  fireResistanceInner: item => getTechnicalValues(item, 'fireResistanceInner'),

  fireResistanceOuter: item => getTechnicalValues(item, 'fireResistanceOuter'),

  fireBehavior: item => getTechnicalValues(item, 'fireBehavior'),

  heatTransferCoefficient: item => getTechnicalValues(item, 'heatTransferCoefficient'),

  impactSoundLevel: item => getTechnicalValues(item, 'impactSoundLevel'),

  insulation: item => getCompositionPartValues(item, 'insulation'),

  screed: item => getCompositionPartValues(item, 'screed'),

  soundReductionIndex: item => getTechnicalValues(item, 'soundReductionIndex'),
  
  pinsulation: item => getCompositionPartValues(item, 'pinsulation'),

  outerPlanking: item => getCompositionPartValues(item, 'outerPlanking'),

  render: item => {
    const values = getCompositionPartValues(item, 'render')
    return values.length > 0 ? values : [null]
  },

  innerPlanking1: item => {
    const values = getCompositionPartValues(item, 'innerPlanking1')
    return values.length > 0 ? values : [null]
  },

  innerPlanking2: item => {
    const values = getCompositionPartValues(item, 'innerPlanking2')
    return values.length > 0 ? values : [null]
  },

  innerPlanking3: item => {
    const values = getCompositionPartValues(item, 'innerPlanking3')
    return values.length > 0 ? values : [null]
  },

  stand: item => {
    const values = getCompositionPartValues(item, 'stand')
    return values.length > 0 ? values : [null]
  },

  compartmentInsulation: item => getCompositionPartValues(item, 'compartmentInsulation'),

  suspendedCeiling: item => {
    const values = getCompositionPartValues(item, 'suspendedCeiling')
    return values.length > 0 ? values : [null]
  },

  underfloorHeating: item => {
    const values = getCompositionPartValues(item, 'underfloorHeating')
    return values.length > 0 ? values : [null]
  },

  soundInsulation: item => {
    const values = getCompositionPartValues(item, 'soundInsulation')
    return values.length > 0 ? values : [null]
  },

  woodenPanel: item => {
    const values = getCompositionPartValues(item, 'woodenPanel')
    return values.length > 0 ? values : [null]
  }

}

export const validate = (name, value) => {
  let result = []

  const values = availables[name] ? availables[name] : []
  if (Array.isArray(value)) {
    for (let i = 0; i < value.length; i++) {
      if (values.indexOf(value[i]) >= 0) result.push(value[i])
    }
  } else if (values.indexOf(value) >= 0) result = [value]

  return result
}
